var HtmlComponent_default = {
  "htmlComponent": "_7C5x2",
  "htmlComponent_placeholder": "Yi6-G"
};
export {
  HtmlComponent_default as default
};
//# sourceMappingURL=HtmlComponent-scss.js.map
